module.exports = __webpack_public_path__ + "src/assets/games/15/150.jpg";